"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTapeBuilderNativeOperationNode = exports.isTapeBuilderNativeOperationType = exports.isTapeBuilderOrBBPLOperationNode = exports.isTapeBuilderTapeNode = exports.isTapeBuilderFileNode = exports.isTapeBuilderGeneratedTapeNode = exports.isTapeBuilderRawTapeNode = exports.isRawNodeType = exports.getFriendlyNameForNode = exports.getArtifactSlugForTapeNode = exports.getUITapeNodeByType = exports.getUITapeNodeByArtifactType = exports.getUINodeByType = exports.getTapeNodeByType = exports.getOperationNodeByType = exports.uiNodes = exports.tapeNodes = exports.operationNodes = exports.generateXlsx2Csv2Config = exports.types = void 0;
// here we import all the uiNodes
const common_1 = require("@finley-technologies/common");
const uinode_1 = require("./operations/ai2csv/uinode");
const uinode_2 = require("./operations/asset2json/uinode");
const uinode_3 = require("./operations/attachHeader/uinode");
const uinode_4 = require("./operations/calcagent/uinode");
const uinode_5 = require("./operations/edit/uinode");
const uinode_6 = require("./operations/filter/uinode");
const uinode_7 = require("./operations/flatten/uinode");
const uinode_8 = require("./operations/join/uinode");
const uinode_9 = require("./operations/pdf2csv/uinode");
const uinode_10 = require("./operations/preFilter/uinode");
const uinode_11 = require("./operations/pyCsvVirtualSheet/uinode");
const uinode_12 = require("./operations/pyXlsx2csv2/uinode");
const uinode_13 = require("./operations/pyXlsxVirtualSheet2Csv/uinode");
const uinode_14 = require("./operations/sanitize/uinode");
const uinode_15 = require("./operations/stack/uinode");
const uinode_16 = require("./operations/unzip/uinode");
const uinode_17 = require("./operations/verify/uinode");
const uinode_18 = require("./operations/xlsx2csv/uinode");
const uinode_19 = require("./operations/xlsx2csv2/uinode");
const uinode_20 = require("./tapes/assigned-repayment-tape/uinode");
const uinode_21 = require("./tapes/bus-certificate/uinode");
const uinode_22 = require("./tapes/config-tape/uinode");
const uinode_23 = require("./tapes/datalake-tape/uinode");
const uinode_24 = require("./tapes/dbnode/uinode");
const uinode_25 = require("./tapes/direct-insert-borrowing-base-report/uinode");
const uinode_26 = require("./tapes/direct-insert-financial-covenants/uinode");
const uinode_27 = require("./tapes/direct-insert-portfolio-covenant/uinode");
const uinode_28 = require("./tapes/direct-insert-portfolio-covenants/uinode");
const uinode_29 = require("./tapes/fin-statement/uinode");
const uinode_30 = require("./tapes/forwarded-tape/uinode");
const uinode_31 = require("./tapes/generated-borrowing-base-report/uinode");
const uinode_32 = require("./tapes/generated-cash-balance-feed/uinode");
const uinode_33 = require("./tapes/generated-covenant-loan-tape/uinode");
const uinode_34 = require("./tapes/generated-financial-data/uinode");
const uinode_35 = require("./tapes/generated-funding-request/uinode");
const uinode_36 = require("./tapes/generated-loan-tape/uinode");
const uinode_37 = require("./tapes/generated-receivable-invoice/uinode");
const uinode_38 = require("./tapes/generated-receivable-response-tape/uinode");
const uinode_39 = require("./tapes/generated-repayment-tape/uinode");
const uinode_40 = require("./tapes/generated-supplemental-tape/uinode");
const uinode_41 = require("./tapes/intermediate-tape/uinode");
const uinode_42 = require("./tapes/limited-partners-tape/uinode");
const uinode_43 = require("./tapes/org-provided-input/uinode");
const uinode_44 = require("./tapes/org-provided-inputs/uinode");
const uinode_45 = require("./tapes/raw-cash-balance-feed/uinode");
const uinode_46 = require("./tapes/raw-loan-tape/uinode");
const uinode_47 = require("./tapes/raw-receivable-documentation/uinode");
const uinode_48 = require("./tapes/raw-repayment-tape/uinode");
const uinode_49 = require("./tapes/raw-supplemental-tape/uinode");
const uinode_50 = require("./tapes/raw-zip-tape/uinode");
const uinode_51 = require("./tapes/reconciled-bus-tape/uinode");
const uinode_52 = require("./tapes/upload-to-datalake/uinode");
const uinode_53 = require("./tapes/valley-bank-ingest/uinode");
const uinode_54 = require("./tapes/valley-bank-sls-commitment/uinode");
const uinode_55 = require("./tapes/valley-bank-sls-ingest/uinode");
const uinode_56 = require("./tapes/wait-for-datalake/uinode");
const types = __importStar(require("./uinodeTypes"));
exports.types = types;
// @xlsx2csv: temporary - remove after migration
var generateXlsx2Csv2Config_1 = require("./generateXlsx2Csv2Config");
Object.defineProperty(exports, "generateXlsx2Csv2Config", { enumerable: true, get: function () { return generateXlsx2Csv2Config_1.generateXlsx2Csv2Config; } });
exports.operationNodes = {
    // pre-sanitize operations
    // these are operations that do not have tapeDefinitions associated with them.
    operation_asset2json: uinode_2.operation_asset2json,
    operation_unzip: uinode_16.operation_unzip,
    operation_attachHeader: uinode_3.operation_attachHeader,
    operation_xlsx2Csv: uinode_18.operation_xlsx2Csv,
    operation_pdf2Csv: uinode_9.operation_pdf2Csv,
    operation_preFilter: uinode_10.operation_preFilter,
    // post sanitize operations
    // these are operations that have tapeDefinitions associated with them.
    operation_sanitize: uinode_14.operation_sanitize,
    operation_pyXlsx2Csv2: uinode_12.operation_pyXlsx2Csv2,
    operation_pyXlsxVirtualSheet2Csv: uinode_13.operation_pyXlsxVirtualSheet2Csv,
    operation_pyCsvVirtualSheet: uinode_11.operation_pyCsvVirtualSheet,
    operation_ai2Csv: uinode_1.operation_ai2Csv,
    operation_xlsx2Csv2: uinode_19.operation_xlsx2Csv2,
    operation_edit: uinode_5.operation_edit,
    operation_filter: uinode_6.operation_filter,
    operation_flatten: uinode_7.operation_flatten,
    operation_join: uinode_8.operation_join,
    operation_calcAgent: uinode_4.operation_calcAgent,
    operation_verify: uinode_17.operation_verify,
    operation_stack: uinode_15.operation_stack,
};
const operationNodeArray = Object.values(exports.operationNodes);
exports.tapeNodes = {
    // Raw
    file_rawLoanTape: uinode_46.file_rawLoanTape,
    file_rawCashBalanceFeed: uinode_45.file_rawCashBalanceFeed,
    file_rawReceivableDocumentation: uinode_47.file_rawReceivableDocumentation,
    file_rawRepaymentTape: uinode_48.file_rawRepaymentTape,
    file_rawSupplementalTape: uinode_49.file_rawSupplementalTape,
    file_rawZipTape: uinode_50.file_rawZipTape,
    // special node to keep borrower config
    file_configTape: uinode_22.file_configTape,
    // intermediate/generated
    file_intermediateTape: uinode_41.file_intermediateTape,
    file_generatedLoanTape: uinode_36.file_generatedLoanTape,
    file_generatedCovenantLoanTape: uinode_33.file_generatedCovenantLoanTape,
    file_generatedCashBalanceFeed: uinode_32.file_generatedCashBalanceFeed,
    file_generatedRepaymentTape: uinode_39.file_generatedRepaymentTape,
    file_generatedReceivableResponseTape: uinode_38.file_generatedReceivableResponseTape,
    file_generatedBorrowingBaseReport: uinode_31.file_generatedBorrowingBaseReport,
    file_directInsertBorrowingBaseReport: uinode_25.file_directInsertBorrowingBaseReport,
    file_directInsertPortfolioCovenant: uinode_27.file_directInsertPortfolioCovenant,
    file_directInsertPortfolioCovenants: uinode_28.file_directInsertPortfolioCovenants,
    file_directInsertFinancialCovenants: uinode_26.file_directInsertFinancialCovenants,
    file_valley_bank_ingest: uinode_53.file_valley_bank_ingest,
    file_valley_bank_sls_ingest: uinode_55.file_valley_bank_sls_ingest,
    file_valley_bank_sls_commitment: uinode_54.file_valley_bank_sls_commitment,
    file_assignedRepaymentTape: uinode_20.file_assignedRepaymentTape,
    file_reconciledBusTape: uinode_51.file_reconciledBusTape,
    file_busCertificate: uinode_21.file_busCertificate,
    // data forwarding
    file_forwardedTape: uinode_30.file_forwardedTape,
    // data lake
    file_uploadToDatalake: uinode_52.file_uploadToDatalake,
    file_waitForDataLakeTable: uinode_56.file_waitForDataLakeTable,
    file_dataLakeTape: uinode_23.file_dataLakeTape,
    file_limitedPartnersTape: uinode_42.file_limitedPartnersTape,
    // Final
    file_generatedFundingRequest: uinode_35.file_generatedFundingRequest,
    file_generatedReceivableInvoice: uinode_37.file_generatedReceivableInvoice,
    file_generatedSupplementalTape: uinode_40.file_generatedSupplementalTape,
    file_financialData: uinode_34.file_financialData,
    file_finStatement: uinode_29.file_finStatement,
    file_orgProvidedInput: uinode_43.file_orgProvidedInput,
    file_orgProvidedInputs: uinode_44.file_orgProvidedInputs,
    // Special one for Monitor mode.
    db_node: uinode_24.db_node,
};
const tapeNodeArray = Object.values(exports.tapeNodes);
exports.uiNodes = [...operationNodeArray, ...tapeNodeArray];
const getOperationNodeByType = (nodeType) => {
    const uiNode = exports.operationNodes[nodeType];
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    return uiNode;
};
exports.getOperationNodeByType = getOperationNodeByType;
const getTapeNodeByType = (nodeType) => {
    const uiNode = exports.tapeNodes[nodeType];
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    return uiNode;
};
exports.getTapeNodeByType = getTapeNodeByType;
const getUINodeByType = (nodeType) => {
    const uiNode = exports.uiNodes.find((node) => node.nodeType === nodeType);
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    return uiNode;
};
exports.getUINodeByType = getUINodeByType;
const getUITapeNodeByArtifactType = (artifactType) => {
    const uiNode = tapeNodeArray.find((node) => !node.isOperation && node.artifactType === artifactType);
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for artifactType: ${artifactType}`);
    (0, common_1.finleyAssert)(!uiNode.isOperation, `isOperation uiNode found for artifactType: ${artifactType}`);
    return uiNode;
};
exports.getUITapeNodeByArtifactType = getUITapeNodeByArtifactType;
const getUITapeNodeByType = (nodeType) => {
    const uiNode = tapeNodeArray.find((node) => node.nodeType === nodeType);
    (0, common_1.finleyAssert)(uiNode, `No uiNode found for nodeType: ${nodeType}`);
    (0, common_1.finleyAssert)(!uiNode.isOperation, `!isOperation uiNode found for nodeType: ${nodeType}`);
    (0, common_1.finleyAssert)(uiNode.nodeType === nodeType, 'nodeType mismatch');
    return uiNode;
};
exports.getUITapeNodeByType = getUITapeNodeByType;
const getArtifactSlugForTapeNode = (tapeNode) => {
    const uiNode = (0, exports.getUITapeNodeByType)(tapeNode.metadata.tapeBuilderNodeType);
    (0, common_1.finleyAssert)(!uiNode.isOperation, 'node cannot be operation');
    return uiNode.getArtifactSlug(tapeNode);
};
exports.getArtifactSlugForTapeNode = getArtifactSlugForTapeNode;
const getFriendlyNameForNode = (node) => {
    return (0, exports.getUINodeByType)(node.metadata.tapeBuilderNodeType).getFriendlyName(node);
};
exports.getFriendlyNameForNode = getFriendlyNameForNode;
const isRawNodeType = (nodeType) => {
    const uiNode = (0, exports.getUINodeByType)(nodeType);
    return !uiNode.isOperation && uiNode.isRaw;
};
exports.isRawNodeType = isRawNodeType;
const isTapeBuilderRawTapeNode = (obj) => {
    return (0, exports.isRawNodeType)(obj.metadata.tapeBuilderNodeType);
};
exports.isTapeBuilderRawTapeNode = isTapeBuilderRawTapeNode;
const isTapeBuilderGeneratedTapeNode = (obj) => {
    const uiNode = (0, exports.getUINodeByType)(obj.metadata.tapeBuilderNodeType);
    return !uiNode.isOperation && !uiNode.isRaw && !uinode_24.db_node.isNode(obj);
};
exports.isTapeBuilderGeneratedTapeNode = isTapeBuilderGeneratedTapeNode;
const isTapeBuilderFileNode = (obj) => {
    return (0, exports.isTapeBuilderRawTapeNode)(obj) || (0, exports.isTapeBuilderGeneratedTapeNode)(obj);
};
exports.isTapeBuilderFileNode = isTapeBuilderFileNode;
const isTapeBuilderTapeNode = (obj) => {
    return (0, exports.isTapeBuilderFileNode)(obj) || uinode_22.file_configTape.isNode(obj);
};
exports.isTapeBuilderTapeNode = isTapeBuilderTapeNode;
const isTapeBuilderOrBBPLOperationNode = (obj) => {
    const uiNode = (0, exports.getUINodeByType)(obj.metadata.tapeBuilderNodeType);
    return uiNode.isOperation;
};
exports.isTapeBuilderOrBBPLOperationNode = isTapeBuilderOrBBPLOperationNode;
const tapeBuilderNativeOperationTypes = [
    'tapebuilder_postSanitize',
    'tapebuilder_preSanitize',
];
const isTapeBuilderNativeOperationType = (nodeType) => {
    const uiNode = (0, exports.getUINodeByType)(nodeType);
    return (uiNode.isOperation &&
        tapeBuilderNativeOperationTypes.includes(uiNode.operationType));
};
exports.isTapeBuilderNativeOperationType = isTapeBuilderNativeOperationType;
const isTapeBuilderNativeOperationNode = (obj) => {
    return (0, exports.isTapeBuilderNativeOperationType)(obj.metadata.tapeBuilderNodeType);
};
exports.isTapeBuilderNativeOperationNode = isTapeBuilderNativeOperationNode;
//# sourceMappingURL=uiNodes.js.map